export const orientation = {
	TextImage: "0",
	ImageText: "1"
}